import React from "react"
import styles from "./styles.scss"
import FaIcon from "@fortawesome/react-fontawesome"
import HoverLink from "components/HoverLink"
import cx from "classnames"

class ContactPerson extends React.Component {
  render() {
    const { name, position, image, email, phoneNumber, className } = this.props
    const tel = phoneNumber.replace(/\s/g, "")

    return (
      <div className={cx(styles.container, className)}>
        <div className={styles.nameRow}>
          <img
            src={image}
            alt={`SAITS ${position}, ${name}`}
            className={styles.image}
          />
          <div className={styles.nameAndPosition}>
            <b>{name}</b>
            <span>{position}</span>
          </div>
        </div>
        <div className={styles.contactRow}>
          <div className={styles.callContainer}>
            <span>
              <FaIcon icon={["far", "phone"]} /> Ring
            </span>
            <HoverLink>
              <a href={`tel:${tel}`} title={`Ring ${name}`}>
                {phoneNumber}
              </a>
            </HoverLink>
          </div>
          <div className={styles.emailContainer}>
            <span>
              <FaIcon icon={["far", "envelope"]} /> Mejla
            </span>
            <HoverLink>
              <a href={`mailto:${email}`} title={`Mejla ${name}`}>
                {email}
              </a>
            </HoverLink>
          </div>
        </div>
      </div>
    )
  }
}

export default ContactPerson



// WEBPACK FOOTER //
// ./src/components/Contact/ContactPerson/index.jsx